import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  private signOutTimer: number | null = null;

  constructor(private authService: AuthService) {}

  startAutoSignOut() {
    this.signOutTimer = window.setTimeout(() => this.signOut(), 24 * 60 * 60 * 1000);
  }

  resetAutoSignOut() {
    if (this.signOutTimer !== null) {
      clearTimeout(this.signOutTimer);
    }
    this.startAutoSignOut();
  }

  signOut() {
    if (this.signOutTimer !== null) {
      clearTimeout(this.signOutTimer);
    }
    this.authService.logout();
  }
}
